<div class="chat"
     #chat
     (window:resize)="onResize($event)">
  <header class="chat__header">
    <div class="chat__tabs">
      <span class="chat__title chat__title--chat"
            (click)="setTab(1)"
            [ngClass]="{
            'chat__title--active': isSelected(1)
            }">
        <stusan-icon icon="menu-chat"
                     class="chat__icon"
                     style="width: 24px; height: 24px;"
        >
        </stusan-icon>
        Chat
        <span class="chat__notify"
              *ngIf="(notify$ | async)">
          <ng-container *ngIf="(notify$ | async) < 10">{{ notify$ | async }}</ng-container>
          <ng-container *ngIf="(notify$ | async) >= 10">10+</ng-container>
        </span>
      </span>
      <span class="chat__title chat__title--users"
            (click)="setTab(2)"
            [ngClass]="{'chat__title--active': isSelected(2)}">
        <stusan-icon icon="participants"
                     class="chat__icon"
                     style="width: 25px; height: 25px;"
        ></stusan-icon>
        Participants
      </span>
    </div>
    <button class="chat__close"
            type="button"
            (click)="closeMenu($event)"
    >
      <stusan-icon icon="close"
                   class="chat__icon chat__icon--close"
                   style="width: 30px; height: 30px; fill: rgba(0,0,0,.14);"
      ></stusan-icon>
      <stusan-icon icon="arrow"
                   class="chat__icon chat__icon--arrow"
                   style="width: 12px; height: 20px; fill: var(--chat-icon);"
      ></stusan-icon>
    </button>
  </header>
  <section class="chat__body"
           #scroll
           (click)="notify$.next(0)"
           [ngClass]="{'chat__body--visible': (loading$ | async) !== true}"
  >

    <div [ngSwitch]="tab">
      <ng-container *ngSwitchCase="1"
      >
        <div class="chat-entry"
             [ngClass]="{'chat-entry--own': message.user.id === (myUid | async)}"
             *ngFor="let message of (messages$ | async); index as i; trackBy:messageBySentAt"
        >
          <div class="chat-entry__col">
            <div *ngIf="!message.user.photoURL; else avatar">
          <span class="chat-entry__avatar">
            <span class="chat-entry__pic avatar"
                  [attr.alt]="message.user.displayName"
            ></span>
            <span class="chat-entry__char">{{ message.user.displayName | firstWord }}</span>
          </span>
            </div>
            <ng-template #avatar>
          <span class="avatar">
            <img [attr.src]="message.user.photoURL"
                 class="avatar__pic"
                 referrerpolicy="no-referrer"
            >
          </span>
            </ng-template>
          </div>
          <div class="chat-entry__col chat-entry__col--right">
            <ul class="chat-entry__info">
              <li class="chat-entry__name">{{ message.user.displayName }}</li>
              <li class="chat-entry__date">
                <time [attr.datetime]="message.sentAt">
                  {{ formatDate(message.sentAt) | date:'MMM d, y, h:mm a' }}
                </time>
              </li>
            </ul>
            <div class="chat-entry__text"
                 [innerHtml]="message.text | linkify"
            ></div>
            <!--<div class="chat-entry__text">-->
            <!--{{ message.text }}-->
            <!--</div>-->
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="2">
        <div class="chat-entry"
             *ngFor="let user of (users$ | async); index as i; trackBy:userBySentAt"
        >
          <div class="chat-entry__col">
            <div *ngIf="!user.user.photoURL; else avatar">
          <span class="chat-entry__avatar">
            <span class="chat-entry__pic avatar"
                  [attr.alt]="user.user.displayName">
            </span>
            <span class="chat-entry__char">{{ user.user.displayName | firstWord }}</span>
          </span>
            </div>
            <ng-template #avatar>
          <span class="avatar">
            <img [attr.src]="user.user.photoURL" class="avatar__pic" referrerpolicy="no-referrer">
          </span>
            </ng-template>
          </div>
          <div class="chat-entry__col chat-entry__col--right">
            <div class="chat-entry__text chat-entry__text--user">
              {{ user.user.displayName }}
            </div>
          </div>
          <div *ngIf="this.likes[0]?.myStars?.includes(user.user.id)"
               class="chat-entry__star"
               (click)="setLeader(user.userId)">
            <stusan-icon icon="star"
                         [style.fill]="'#fff'">
            </stusan-icon>
          </div>
        </div>
      </ng-container>
    </div>
  </section>
  <footer class="chat__footer" *ngIf="isSelected(1)">
    <input type="text"
           placeholder="Type something"
           class="chat__input disabled"
           [(ngModel)]="text"
           maxlength="1000"
           (blur)="closeKeyboard()"
           (click)="notify$.next(0)"
           #message
           (keypress)="$event.keyCode === 13 && isValidLength(text) ? sendText(text) : null"
    >
    <button class="chat__submit"
            type="submit"
            (click)="sendText(text)"
            [disabled]="!isValidLength(text)">
      <stusan-icon icon="message"
                   class="chat__icon"
                   style="width: 22px; height: 22px; fill: var(--chat-submit);">
      </stusan-icon>
    </button>
  </footer>
</div>
